import React, { useState } from 'react';
import { Navigate, useParams } from 'react-router';

import { faHashtag } from '@fortawesome/pro-regular-svg-icons/faHashtag';

import { IconLink } from '../../../../common/components/IconLink';
import { Resource } from '../../../../common/constants/resource';
import { CodebackDrawer } from '../../../detail/drawer/codeback/CodebackDrawer';
import styles from './styles.module.scss';

const OrderCodebacks = () => {
  // For controlling the OrderCodebacks drawer
  const [isOpen, setIsOpen] = useState(false);

  const iconContainerClasses = `${styles.IconLinkContainer} ${styles.RightNavIconLinkContainer} ${styles.RightSidebar}`;

  const { id } = useParams<{ id: string }>();
  if (id === undefined) {
    return <Navigate to={{ pathname: '/' }} />;
  }

  return (
    <>
      <CodebackDrawer
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        applicationId={id}
      />
      <IconLink
        onClick={() => setIsOpen(true)}
        icon={faHashtag}
        copy={Resource.TASK_TITLE_ORDER_MIB_CODEBACK}
        iconContainerClassName={iconContainerClasses}
        iconClassName={styles.Icon}
      />
    </>
  );
};

export default OrderCodebacks;
